var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticClass:"survey-text-input-answer",attrs:{"placeholder":"Значение","type":"text"},domProps:{"value":_vm.answer},on:{"input":function (event) { return _vm.$emit('setAnswer', event.target.value); }}})}
var staticRenderFns = []

export { render, staticRenderFns }